/**
 * Use an "index" exporter to make "import" paths cleaner; we can then "import" named Providers with a single import statement elsewhere in the app.
 */

export { default as TestWidgetProvider } from './TestWidgetProvider'